var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"default-layout-page",attrs:{"light":""}},[_c('HeaderToolbar',[_c('HeaderActions',{attrs:{"slot":"actions"},slot:"actions"})],1),_c('v-content',[_c('v-container',{attrs:{"pa-0":"","fill-height":""}},[_vm._t("default")],2),_c('SnackbarNotification')],1),_c('SatFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }